import commonMixin from '@/mixins/templates/common';
import { ABtn } from '@maisaedu/ui-components-a-btn';

import { TemplateName } from '@/helpers/templateType';

export default {
  mixins     : [commonMixin],
  components : {
    ABtn
  },
  props: {
    items: {
      type    : Array,
      default : () => []
    },
    textValue: {
      type    : String,
      default : ''
    },
    isOpen: {
      type    : Boolean,
      default : false
    },
    isLoadingMoveTo: {
      type    : Boolean,
      default : false
    },
    showMoveToRoot: {
      type    : Boolean,
      default : true
    }
  },
  data() {
    return {
      TemplateName,
      selectedItem: null
    };
  },
  computed: {
    templateStreaming() {
      return this.templateName === this.TemplateName.STREAMING;
    },
    filteredItems() {
      return this.items?.filter((item) => !item.children?.find(child => child.id === item.id));
    }
  },
  watch: {
    isOpen(newValue) {
      if (!newValue) {
        this.selectedItem = null;
      }
    }
  },
  methods: {
    selectTopic(item) {
      if (item === this.selectedItem) {
        this.selectedItem = null;
      } else {
        this.selectedItem = item;
      }
    },
    closeModal() {
      this.$emit('closeModal');
      this.selectedItem = null;
      this.scrollToTop();
    },
    scrollToTop() {
      const element = document.getElementsByClassName('wrapper-list')[0];

      if (element && (element.scrollHeight > element.clientHeight)) {
        element.scrollTop = 0;
      }
    }
  }
};
